import { AuditFragment } from "src/api/api.generated";
import { compareDates } from "src/utils/date";

export function getChanges({ audit, audits, changesToGet }: { audit: AuditFragment; audits: AuditFragment[]; changesToGet: string[] }) {
  const changes: Record<string, unknown> = changesToGet.reduce((prev, change) => ({ ...prev, [change]: change in (audit.changes ?? {}) ? audit.changes[change] : null }), {})

  if (Object.values(changes).every((value) => value != null)) {
    return changes
  }

  const previousAudits = audits
    .filter((auditToCheck) => auditToCheck.entityId === audit.entityId && compareDates(auditToCheck.timestamp, audit.timestamp, true) <= 0)
    .sort((firstAudit, secondAudit) => {
      return secondAudit.timestamp.getTime() - firstAudit.timestamp.getTime()
    })

  for (const previousAudit of previousAudits) {
    for (const change of changesToGet) {
      if (changes[change] === null && change in (previousAudit.changes ?? {})) {
        changes[change] = previousAudit.changes[change]
      }
      if (Object.values(changes).every((value) => value != null)) {
        return changes
      }
    }
  }
}
